import { Container, Heading, Text, Button } from '@radix-ui/themes';
import { Link } from '@trashlab/sitesapp/src/components/shared/link';

export const NotFoundComponent = () => {
  return (
    <Container size="2" className="py-8">
      <Heading size="8" className="mb-4">
        Page Not Found
      </Heading>
      <Text as="p" size="3" className="mb-4">
        Sorry, we couldn't find the page you're looking for.
      </Text>
      <Button
        asChild
        className="relative inline-flex items-center justify-center"
      >
        <Link href="/" className="inline-block">
          Return Home
        </Link>
      </Button>
    </Container>
  );
};
